// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"feba760c","257":"2bf78e7a","453":"8ab44547","591":"49eeea76"}[chunkId] + ".chunk.js";
};